export const mockData = {
  hero: {
    tagline: "Revive Your Hair. Redefine Your Confidence.",
    ctaButton: "Shop Now"
  },

  benefits: [
    {
      icon: "Award",
      title: "Strengthens Roots",
      description:
        "Advanced keratin complex penetrates deep into hair follicles, reinforcing from the root up for visibly stronger, more resilient hair."
    },
    {
      icon: "Sparkles",
      title: "Adds Brilliant Shine",
      description:
        "Premium argan oil and silk proteins create a luminous, mirror-like shine that catches light beautifully throughout the day."
    },
    {
      icon: "Leaf",
      title: "100% Natural Formula",
      description:
        "Carefully curated botanical extracts and essential oils deliver powerful results without harsh chemicals or sulfates."
    }
  ],

  about: {
    description:
      "At Hairbalife, we believe that exceptional hair care begins with the finest natural ingredients and cutting-edge scientific research. Our premium formulations combine centuries-old botanical wisdom with modern innovation, creating luxurious products that transform your hair care ritual into a moment of pure indulgence.",
    values: [
      "Cruelty-Free",
      "Sulfate-Free",
      "Paraben-Free",
      "Eco-Friendly",
      "Premium Quality"
    ]
  },

  product: {
    name: "Get Yours Now Just For",
    price: "14.99",
    originalPrice: "34.99",
    description: "Luxury hair revitalization system"
  },

  // 🧴 Product Gallery
  productGallery: [
    {
      id: 1,
      name: "Hairbalife Repair Shampoo - 500 ml",
      price: 14.99,
      image: "https://picsum.photos/seed/hairbalife-shampoo/900/1200",
      description: "Keratin-rich daily shampoo for damaged and fragile hair",
      category: "Shampoo"
    },
    {
      id: 2,
      name: "Hairbalife Nourish Conditioner - 400 ml",
      price: 16.99,
      image: "https://picsum.photos/seed/hairbalife-conditioner/900/1200",
      description: "Moisture-lock conditioner with argan and silk proteins",
      category: "Conditioner"
    },
    {
      id: 3,
      name: "Hairbalife Scalp Detox Scrub - 250 ml",
      price: 18.49,
      image: "https://picsum.photos/seed/hairbalife-scalp/900/1200",
      description: "Gentle exfoliating scalp scrub with tea tree and mint",
      category: "Scalp Care"
    },
    {
      id: 4,
      name: "Hairbalife Strength Mask - 300 ml",
      price: 21.99,
      image: "https://picsum.photos/seed/hairbalife-mask/900/1200",
      description: "Weekly intensive mask for breakage-prone hair",
      category: "Treatment"
    },
    {
      id: 5,
      name: "Hairbalife Heat Shield Spray - 200 ml",
      price: 25.99,
      image: "https://picsum.photos/seed/hairbalife-spray/900/1200",
      description: "Lightweight thermal protectant for blow-dry and styling",
      category: "Styling"
    },
    {
      id: 6,
      name: "Hairbalife Volume Mousse - 180 ml",
      price: 15.49,
      image: "https://picsum.photos/seed/hairbalife-mousse/900/1200",
      description: "Flexible volume mousse with humidity resistance",
      category: "Styling"
    },
    {
      id: 7,
      name: "Hairbalife Frizz Control Serum - 120 ml",
      price: 35.99,
      image: "https://picsum.photos/seed/hairbalife-serum/900/1200",
      description: "Gloss finish serum that smooths frizz and flyaways",
      category: "Serum"
    },
    {
      id: 8,
      name: "Hairbalife Overnight Repair Oil - 100 ml",
      price: 27.99,
      image: "https://picsum.photos/seed/hairbalife-oil/900/1200",
      description: "Nutrient-dense overnight oil for deep restoration",
      category: "Oil"
    },
    {
      id: 9,
      name: "Hairbalife Starter Ritual Bundle",
      price: 49.99,
      image: "https://picsum.photos/seed/hairbalife-bundle/900/1200",
      description: "Shampoo, conditioner, and mask starter routine set",
      category: "Bundle"
    }
  ],

  // 🎥 Reels Section (comes right after product gallery)
  reels: [
    {
      id: 1,
      title: "Our Natural Process",
      src: "/assets/videos/reel1.mp4"
    },
    {
      id: 2,
      title: "Real Customer Stories",
      src: "/assets/videos/reel2.mp4"
    },
    {
      id: 3,
      title: "The Luxury Within",
      src: "/assets/videos/reel3.mp4"
    }
  ],

  // 💬 Reviews Section
  reviews: [
    {
      id: 1,
      name: "Sarah Klein",
      rating: 5,
      review:
        "Ich war wirklich überrascht, wie weich und gepflegt sich meine Haare schon nach der ersten Wäsche angefühlt haben. Der Duft ist dezent, aber total angenehm, richtig spa-mäßig!",
      image: "/images/customer1.jpeg",
      location: "Berlin"
    },
    {
      id: 2,
      name: "Michael Bauer",
      rating: 5,
      review:
        "Ich hab schon viele Shampoos ausprobiert, aber das hier ist echt das erste, bei dem ich das Gefühl habe, dass meine Haare stärker werden. Es fühlt sich luxuriös an, aber trotzdem natürlich – jeden Cent wert.",
      image: "/images/customer2.jpeg",
      location: "München"
    },
    {
      id: 3,
      name: "Emily Schneider",
      rating: 4,
      review:
        "Mir gefällt vor allem, dass keine Silikone oder Parabene drin sind. Meine Kopfhaut ist viel ruhiger geworden, und meine Haare glänzen schön. Einen halben Stern Abzug nur, weil ich mir eine größere Flasche wünschen würde.",
      image: "/images/customer3.jpeg",
      location: "Hamburg"
    },
    {
      id: 4,
      name: "Laura Meier",
      rating: 5,
      review:
        "I really like this product, would recommend to everyone!",
      image: "/images/customer2.jpeg",
      location: "Köln"
    },
    {
      id: 5,
      name: "Ella More",
      rating: 5,
      review:
        "Ich benutze es jetzt seit etwa drei Wochen und bekomme ständig Komplimente für meine Haare. Sie sind voller, weicher und sehen einfach gesünder aus. Absolut empfehlenswert!",
      image: "/images/customer4.jpeg",
      location: "Köln"
    },
    {
      id: 6,
      name: "Jonas Weber",
      rating: 4,
      review:
        "Angenehmer Duft, sehr gutes Gefühl beim Waschen. Meine Haare fühlen sich kräftiger an, nur der Preis ist etwas hoch, aber Qualität hat halt ihren Preis.",
      image: "/images/customer5.jpeg",
      location: "Frankfurt am Main"
    }
  ],

  // ⚙️ Footer
  footer: {
    links: [
      "Privacy Policy",
      "Terms of Service",
      "Contact Us",
      "Shipping Info",
      "Returns"
    ]
  }
};
